import React, { Fragment, useEffect, useState } from 'react';
import { Col, Dropdown, DropdownItem, DropdownMenu, DropdownToggle, Form, FormGroup, Input, Nav, NavItem, NavLink, Row, TabContent, TabPane } from 'reactstrap';
import classnames from 'classnames';
import moment from 'moment';
import { activateDeactivateStaff, getAssignedOrgAndClinic, updateDefaultOrg, removeOrgClinicAccess, updateDefaultRole, getStaffsById, getStaffRoles, removeUserRoleAccess, updateProfilePhoto, getUserProfile } from '../../../api/User';
import { useDispatch, useSelector } from 'react-redux';
import { failed, success } from '../../../utils/Tostify';
import Loader from '../../../components/Loader/Loader';
import EditUser from './EditUser';
import { decryptData } from '../../../utils/helper';
import CustomPagination from '../../../components/Pagination/CustomPagination';
import { useConfirmDialog } from '../../../hooks/useConfirmDialog';
import "./Users.css";
import AddOrgAccessModal from './AddOrgAccessModal';
import { useNavigate } from 'react-router';
import { platformLayout } from '../../../utils/constants';
import AddRoleAccessModal from './AddRoleAccessModal';
import { handleFileUpload } from '../../../utils/ImageToBase64';
import { useFormik } from 'formik';
import { forgotPassword } from '../../../api/auth';
import noProfileImg from "../../../../src/assets/images/noImage.jpg";
import { Link} from "react-router-dom";
import { userActions } from '../../../context/reducers/user';



function UserDetails({ direction, userDetails, setCurrentTab, roleData, ...args }) {
    let role = localStorage.getItem("userRole");
    let token = useSelector(state => state.userReducer.token);
    const { getConfirmation } = useConfirmDialog();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [activeTab, setActiveTab] = useState('1');
    const [isActive, setIsActive] = useState(userDetails?.active);
    const [dropdownfive, setDropdownfive] = useState([]);
    const [expandedOrg, setExpandedOrg] = useState([]);
    const [assignedOrg, setAssignedOrg] = useState([]);
    const [user, setUser] = useState(userDetails);
    const [userRoles, setUserRoles] = useState();
    const [isLoading, setIsLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [orgToggles, setOrgToggles] = useState({});
    const [clinicToggles, setClinicToggles] = useState({});
    const [showModalAddOrg, setShowModalAddOrg] = useState(false);
    const [showModalAddRole, setShowModalAddRole] = useState(false);
    const [selectedImage, setSelectedImage] = useState(null);
    const [sortConfig, setSortConfig] = useState({ key: "", direction: "asc" }); // Sorting state
    const togglefive = (id) => setDropdownfive(prevState => prevState.includes(id) ? prevState.filter(item => item !== id) : [...prevState, id]);
    const toggle = tab => { if (activeTab !== tab) setActiveTab(tab); };
    const handleActiveInActive = async (e, staffId) => {
        const currentChecked = e.target.checked;
        e.target.checked = !currentChecked;
        let msg = currentChecked === true ? "Activate" : "Deactivate";
        const confirmed = await getConfirmation({
            title: "Attention!",
            entryName: "",
            actionBtnTitle: "Yes",
            message: `Are you sure want to ${msg}`
        });
        if (confirmed) {
            let res;
            try {
                setIsLoading(true);
                res = await activateDeactivateStaff({ dispatch, token, staffId, isActive: currentChecked });
                if (res?.status === "SUCCESS") {
                    setIsActive(currentChecked);
                    setIsLoading(false);
                    success(res?.message);
                } else {
                    setIsLoading(false);
                    failed(res?.message);
                }
            } catch (error) {
                setIsLoading(false);
                failed(res?.message);
            }
        } else {
            e.target.checked = !currentChecked;
        }
    };

    const getAssignedOrg = async (page, limit, searchKey = "") => {
        let res;
        try {
            setIsLoading(true);
            // setSearch(searchKey);
            res = await getAssignedOrgAndClinic({ dispatch, token, page, limit, searchKey, userId: userDetails?._id });
            const responseData = decryptData(res?.data);
            if (res?.status === "SUCCESS") {
                setAssignedOrg(responseData);
                setIsLoading(false);
            }
        } catch (error) {
            failed(res?.message);
            setIsLoading(false);
        }
    };

    const handleExpand = (id) => {
        setExpandedOrg(prev => prev.includes(id) ? prev.filter(orgId => orgId !== id) : [...prev, id]);
    };
    const handlePagination = (page) => {
        getAssignedOrg(page, 10);
    };

    const handleRadio = async (e, id, entryName, radio, orgId) => {
        const isAccess = user?.organizations?.find((obj) => obj.organizationId == id)?.isAccess;
        const isAccessClinic = user?.organizations?.find((obj) => obj?.organizationId == orgId)?.clinicId?.includes(id);
        if (!isAccess && radio == "org") {
            failed("To make it default please enable access for organization.");
            return true;
        } else if (!isAccessClinic && radio == "clinic") {
            failed("To make it default please enable access for Clinic.");
            return true;
        }
        const isChecked = e.target.checked;
        const values = { isChecked };
        const confirmed = await getConfirmation({
            title: "Attention!",
            entryName,
            actionBtnTitle: "Yes",
            message: isChecked ? `Are you sure want to make it default!` : `Are you sure want to remove it from default!`
        });

        if (confirmed) {
            let res;
            try {
                setIsLoading(true);
                if (radio == "org") {
                    res = await updateDefaultOrg({ values, dispatch, token, userId: userDetails?._id, defaultOrgId: id, clinicId: "", orgId: id });
                }
                else {
                    res = await updateDefaultOrg({ values, dispatch, token, userId: userDetails?._id, defaultOrgId: "", clinicId: id, orgId: orgId });
                }
                if (res?.status === "SUCCESS") {
                    await getAssignedOrg(1, 10);
                    await getUser();
                    setIsLoading(false);
                    success(res?.message);
                } else {
                    setIsLoading(false);
                    failed(res?.message);
                }
            } catch (error) {
                failed(res?.message);
                setIsLoading(false);
            }
        }
    };

    const handleRoleRadio = async (role) => {
        if (!role?.active) {
            failed(`Role ${role?.roleName} is Not active to make it default.`);
            return;
        }
        const isAnyOrgActive = assignedOrg?.items?.filter(( value ) => value?.organization?.active === true);
        if(role.portalLayout === platformLayout.Organization && isAnyOrgActive.length === 0){
            failed(`No assigned Organization is active to make it default.`);
            return;
        }
        const confirmed = await getConfirmation({
            title: "Attention!",
            entryName: "",
            actionBtnTitle: "Yes",
            message: `Are you sure want to make role ${role?.roleName} default!`
        });

        if (confirmed) {
            let values = { userId: userDetails?._id, roleId: role._id, roleName: role?.roleName };
            let res;
            try {
                setIsLoading(true);
                res = await updateDefaultRole({ values, dispatch, token });
                if (res?.status === "SUCCESS") {
                    await getUserRole();
                    await getUser();
                    setIsLoading(false);
                    success(res?.message);
                } else {
                    setIsLoading(false);
                    failed(res?.message);
                }
            } catch (error) {
                failed(res?.message);
                setIsLoading(false);
            }
        }
    };

    const getUser = async () => {
        let res;
        try {
            setIsLoading(true);
            //   setSearch(searchKey);
            res = await getStaffsById({ dispatch, token, userId: userDetails?._id });
            const responseData = decryptData(res?.data);
            if (res?.status === "SUCCESS") {
                setUser(responseData);
                setIsLoading(false);
            }
        } catch (error) {
            failed(res?.message);
            setIsLoading(false);
        }
    };
    const getUserRole = async () => {
        let res;
        try {
            setIsLoading(true);
            //   setSearch(searchKey);
            res = await getStaffRoles({ dispatch, token, userId: userDetails?._id });
            const responseData = decryptData(res?.data);
            if (res?.status === "SUCCESS") {
                setUserRoles(responseData);
                setIsLoading(false);
            }
        } catch (error) {
            failed(res?.message);
            setIsLoading(false);
        }
    };

    useEffect(() => {
        getAssignedOrg(assignedOrg?.currentPage, 10);
        getUser();
        getUserRole();
    }, []);

    const handleOrgToggle = async (e, orgId, clinicIdArray) => {
        const isChecked = e.target.checked;
        if (!isChecked) {
            if (user?.defaultLogInOrg == orgId) {
                failed(`This is the default Organization for ${userDetails?.firstName} ${userDetails?.lastName}. Please make another Organization the default before remove the access.`);
                return;
            }
        }
        let msg = e.target.checked === true ? "Enable Access." : "Remove Access.";
        setOrgToggles((prev) => ({ ...prev, [orgId]: isChecked }));
        e.target.checked = !isChecked;
        const confirmed = await getConfirmation({
            title: "Attention!",
            entryName: "",
            actionBtnTitle: "Yes",
            message: `Are you sure want to ${msg}`
        });
        if (confirmed) {
            let values = { isOrgAccess: isChecked, orgId, userId: userDetails?._id, clinicId: "", updateType: "org", clinicIdArray: clinicIdArray };
            let res;
            try {
                setIsLoading(true);
                res = await removeOrgClinicAccess({ values, dispatch, token });
                if (res?.status === "SUCCESS") {
                    await getAssignedOrg(assignedOrg?.currentPage, 10);
                    await getUser();
                    res = await getUserProfile({ dispatch, token, values });
                    const responseData = res?.data;
                    dispatch(userActions.loginSuccess({...responseData,accessToken: token}));
                    setIsLoading(false);
                    if (isChecked) {
                        setClinicToggles((prev) => {
                            const newState = { ...prev };
                            clinicIdArray.forEach((clinicId) => {
                                newState[`${orgId}-${clinicId}`] = isChecked;
                            });
                            return newState;
                        });
                    } else {
                        setClinicToggles((prev) => {
                            const newState = { ...prev };
                            clinicIdArray.forEach((clinicId) => {
                                newState[`${orgId}-${clinicId}`] = isChecked;
                            });
                            return newState;
                        });
                    }
                    success(res?.message);
                } else {
                    setOrgToggles((prev) => ({ ...prev, [orgId]: !isChecked }));
                    setIsLoading(false);
                    failed(res?.message);
                }
            } catch (error) {
                setOrgToggles((prev) => ({ ...prev, [orgId]: !isChecked }));
                setIsLoading(false);
                failed(error?.message);
            } finally {
                setIsLoading(false);
            }
        } else {
            setOrgToggles((prev) => ({ ...prev, [orgId]: !isChecked }));
        }
    };

    const handleClinicToggle = async (e, clinicId, orgId, orgName) => {
        const isChecked = e.target.checked;
        const org = user?.organizations?.find((obj) => obj.organizationId === orgId);
        if (org?.defaultClinic === clinicId) {
            failed(`This is the default hospital for ${userDetails?.firstName} ${userDetails?.lastName}. Please make another hospital the default before remove the access.`);
            return;
        } else if (!org?.isAccess) {
            failed(`Please enable organization ${orgName} access.`);
            setClinicToggles((prev) => ({
                ...prev,
                [`${orgId}-${clinicId}`]: !isChecked
            }));
            return;
        }
        setClinicToggles((prev) => ({
            ...prev,
            [`${orgId}-${clinicId}`]: isChecked
        }));
        let msg = isChecked ? "Enable Access" : "Remove Access";
        const confirmed = await getConfirmation({
            title: "Attention!",
            entryName: "",
            actionBtnTitle: "Yes",
            message: `Are you sure you want to ${msg}?`
        });
        if (confirmed) {
            let values = { isClinicAccess: isChecked, orgId, userId: userDetails?._id, clinicId, updateType: "clinic" };
            try {
                setIsLoading(true);
                const res = await removeOrgClinicAccess({ values, dispatch, token });
                if (res?.status === "SUCCESS") {
                    await getAssignedOrg(assignedOrg?.currentPage, 10);
                    await getUser();
                    const responseData = await getUserProfile({ dispatch, token, values });
                    dispatch(userActions.loginSuccess({...responseData.data,accessToken: token}));
                    setIsLoading(false);
                    success(res?.message);
                } else {
                    setClinicToggles((prev) => ({
                        ...prev,
                        [`${orgId}-${clinicId}`]: !isChecked
                    }));
                    setIsLoading(false);
                    failed(res?.message);
                }
            } catch (error) {
                setClinicToggles((prev) => ({
                    ...prev,
                    [`${orgId}-${clinicId}`]: !isChecked
                }));
                setIsLoading(false);
                failed(error?.message);
            } finally {
                setIsLoading(false);
            }
        } else {
            setClinicToggles((prev) => ({
                ...prev,
                [`${orgId}-${clinicId}`]: !isChecked
            }));
        }
    };

    const handleSort = (key) => {
        let direction = "asc";
        if (sortConfig.key === key && sortConfig.direction === "asc") {
            direction = "desc";
        }
        setSortConfig({ key, direction });
    };
    const handleRemoveAccess = async (userId, orgId) => {
        if (user?.defaultLogInOrg == orgId && hasOrganizationPortalLayout) {
            failed(`This is the default Organization for ${userDetails?.firstName} ${userDetails?.lastName}. Please make another Organization the default before remove the access.`);
            return;
        }
        const confirmed = await getConfirmation({
            title: "Attention!",
            entryName: "",
            actionBtnTitle: "Yes",
            message: `Are you sure want to Remove Organization`
        });
        if (confirmed) {
            let values = { isOrgDeleted: true, orgId: orgId, userId: userId, clinicId: "", updateType: "org" };
            let res;
            try {
                setIsLoading(true);
                res = await removeOrgClinicAccess({ values, dispatch, token });
                if (res?.status === "SUCCESS") {
                    await getAssignedOrg(assignedOrg?.currentPage, 10);
                    const responseData = await getUserProfile({ dispatch, token, values });
                    dispatch(userActions.loginSuccess({...responseData.data,accessToken: token}));
                    setIsLoading(false);
                    success(res?.message);
                } else {
                    setIsLoading(false);
                    failed(res?.message);
                }
            } catch (error) {
                setIsLoading(false);
                failed(error?.message);
            } finally {
                setIsLoading(false);
            }
        }
    };

    const handleImageChange = async(e) => {
		if (e.target.files && e.target.files[0]) {
      const confirmed = await getConfirmation({
        title: "Attention!",
        // entryName,
        actionBtnTitle: "Yes",
        message : `Are you sure want to update the logo ?`
      });
      if (confirmed) {
        setSelectedImage(URL.createObjectURL(e.target.files[0]));
        let res;
        try {
          setIsLoading(true);
          const values = {
            profilePhoto : e.target.files[0]
          };
          let base64OrgLogo = "";
          if (values?.profilePhoto) {
              base64OrgLogo = await handleFileUpload(values?.profilePhoto);
          }
          const fileExtension = values?.profilePhoto?.type?.split("/")[1];
          const ProfilePhotoURL = {
              base64String: base64OrgLogo,
              extension: fileExtension, // Add the file extension to the object
              name: values?.profilePhoto.name
          };
          values.profilePhoto = ProfilePhotoURL;
          res = await updateProfilePhoto({ values, dispatch, token, userId: user?._id });
          if (res?.status == "SUCCESS") {
              await getUser();
              setIsLoading(false);
              success(res?.message);
          }else{
              failed(res.data.message);
              setIsLoading(false);
          }
      } catch (error) {
          setIsLoading(false);
          failed(res?.message);
      }
      }
		}
	};

    const sortData = (data) => {
        if (!sortConfig.key) return data;
        return [...data].sort((a, b) => {
            let aValue = a[sortConfig.key]?.toLowerCase();
            let bValue = b[sortConfig.key]?.toLowerCase();
            if (sortConfig.key === "name") {
                aValue = a.organization?.name || ""; // If contact[0] or name is undefined, use an empty string
                bValue = b.organization?.name || "";
            } if (sortConfig.key === "address") {
                aValue = (a?.organization?.address?.[0]?.city + "," + a?.organization?.address?.[0]?.state || "").toLowerCase();
                bValue = (b?.organization?.address?.[0]?.city + "," + b?.organization?.address?.[0]?.state || "").toLowerCase();
            } else {
                // Convert values to lowercase for case-insensitive sorting
                aValue = (aValue || "").toLowerCase();
                bValue = (bValue || "").toLowerCase();
            }
            if (aValue < bValue) {
                return sortConfig.direction === "asc" ? -1 : 1;
            }
            if (aValue > bValue) {
                return sortConfig.direction === "asc" ? 1 : -1;
            }
            return 0;
        });
    };
    const filteredAndSortedData = sortData(assignedOrg?.items);

    const filteredAndRolesSortedData = sortData(userRoles?.roles);
    const handleRemoveAccessRole = async (role) => {
        if (user.defaultRole.value == role._id) {
            failed(`Please select other role as default to remove access for role ${role?.roleName}`);
            return true;
        }
        const confirmed = await getConfirmation({
            title: "Attention!",
            entryName: "",
            actionBtnTitle: "Yes",
            message: `Are you sure want to Remove access`
        });
        if (confirmed) {
            let res;
            let values = { userId: userDetails?._id, roleId: role?._id, roleName: role?.roleName };
            try {
                setIsLoading(true);
                res = await removeUserRoleAccess({ values, dispatch, token });
                if (res?.status === "SUCCESS") {
                    await getUserRole();
                    await getAssignedOrg();
                    setIsLoading(false);
                    success(res?.message);
                } else {
                    setIsLoading(false);
                    failed(res?.message);
                }
            } catch (error) {
                setIsLoading(false);
                failed(error?.message);
            } finally {
                setIsLoading(false);
            }
        } else {
            return true;
        }
    };

    const hasOrganizationPortalLayout = filteredAndRolesSortedData?.filter(
        role => role?.value?.portalLayout === "Organization"
    ).length > 0;

    const formik = useFormik({
        initialValues: {
            email: ""
        },
        onSubmit: async () => {
        let res;
        try {
            setIsLoading(true);
            const values = { email: userDetails.email, initiatedBy: 'admin' };
            res = await forgotPassword({ values, dispatch});
            if (res?.status === "SUCCESS") {
                setIsLoading(false);
                success(res?.message);
                getUser();
            }else{
            setIsLoading(false);
            failed(res?.data);
            }
        } catch (error) {
            setIsLoading(false);
            failed(res?.message);
        }
    }
    });

    return (
        <Fragment>
            {isLoading && <Loader />}
            {showModal && <EditUser refetch={getUser} userData={user} setShowModal={() => setShowModal(!showModal)} setCurrentTab={setCurrentTab} />}
            {showModalAddOrg && <AddOrgAccessModal assignedOrg={assignedOrg} refetchUser={getUser} refetch={getAssignedOrg} setShowModalAddOrg={() => setShowModalAddOrg(!showModalAddOrg)} userData={userDetails} />}
            {showModalAddRole && <AddRoleAccessModal refetch={getUserRole} setShowModalAddRole={() => setShowModalAddRole(!showModalAddRole)} userId={userDetails?._id} from={"roleToUser"} userData={userDetails}/>}
            <div className='userdetails_container paginator_blk'>
                <div>
                    <Nav tabs>
                        <NavItem>
                            <NavLink
                                className={classnames({ active: activeTab === '1' })}
                                onClick={() => toggle('1')}
                            >
                                User Details
                            </NavLink>
                        </NavItem>
                        {role === platformLayout.Platform ? <NavItem>
                            <NavLink
                                className={classnames({ active: activeTab === '2' })}
                                onClick={() => toggle('2')}
                            >
                                Organizations    ({assignedOrg.items?.length || 0})
                            </NavLink>
                        </NavItem> : null}
                        {role === platformLayout.Platform ? <NavItem>
                            <NavLink
                                className={classnames({ active: activeTab === '3' })}
                                onClick={() => toggle('3')}
                            >
                                Roles ({filteredAndRolesSortedData?.length || 0})
                            </NavLink>
                        </NavItem> : null}
                    </Nav>
                    <TabContent activeTab={activeTab}>
                        <TabPane tabId="1">
                            <Row>
                                <Col sm="12">
                                    <div className='profile_block'>
                                        <div className='profile_main d-flex justify-content-between align-items-center flex-wrap gap-3'>
                                            <div className='profile_info flex-wrap'>
                                                <div className="img_block">
                                                    <div className="img_profile_container">
                                                    {selectedImage ? (
                                                        <img src={selectedImage} alt="Profile" className="img_profile_one" />
                                                    ) : user?.profilePhoto?.signedUrl ? (
                                                        <img src={user.profilePhoto.signedUrl} alt="Profile" className="img_profile_one" />
                                                    ) : (
                                                        <img src={noProfileImg} alt="No Profile" className="img_profile_one" />
                                                    )}
                                                    </div>
													<div className="edit_img">
														<i className='fas fa-pen'></i>
													</div>
													<input
														type="file"
														accept="image/*"
														onChange={handleImageChange}
														className="img_upload_input"
													/>
												</div>
                                                <div>
                                                    <h6>{user?.firstName + " " + user?.lastName}</h6>
                                                    <p>{user?.email}</p>
                                                </div>
                                            </div>
                                            {role === platformLayout.Platform ? <button className='edit_profile' onClick={() => setShowModal(true)}>Edit</button> : null}
                                        </div>
                                         <div className='data_profile'>
                                        <div className='row'>
                                            <div className='col-lg-4 mb-3'>
                                                <h4>Name</h4>
                                                <p>{user?.firstName + " " + user?.lastName}</p>
                                            </div>
                                            <div className='col-lg-4 mb-3'>
                                                <h4>User Role</h4>
                                                <p>{user?.defaultRole?.label}</p>
                                            </div>
                                            <div className='col-lg-4 mb-3'>
                                                <h4>Email</h4>
                                                <p>{user?.email}</p>
                                            </div>
                                            {role === "Platform" && (
                                            <div className='col-lg-4 mb-3'>
                                                <h4>Last Password Change or Reset</h4>
                                                <p>03/02/2023, 12:20 PM</p>
                                            </div>
                                            )}
                                            <div className='col-lg-4 mb-3'>
                                                <h4>Title</h4>
                                                <p>Product Owner</p>
                                            </div>
                                            {role === "Platform" && (
                                            <div className='col-lg-4 mb-3'>
                                                <h4>Failed Login Attempts</h4>
                                                <p>{user?.loginAttempts}</p>
                                            </div>
                                            )}
                                            {userDetails?.organizationName ? <div className='col-lg-4 mb-3'>
                                                <h4>Organization</h4>
                                                <p>{userDetails?.organizationName}</p>
                                            </div> : null}
                                            <div className='col-lg-4 mb-3'>
                                                <h4>Department</h4>
                                                <p>{user?.department}</p>
                                            </div>
                                            <div className='col-lg-4 mb-3'>
                                                <h4>Create Date</h4>
                                                <p>{moment(user?.createdAt).format("MMM-DD-YYYY")}</p>
                                            </div>
                                            <div className='col-lg-4 mb-3'>
                                                <h4>Mobile Phone Number</h4>
                                                <p>{user?.primaryPhone}</p>
                                            </div>
                                            <div className='col-lg-4 mb-3'>
                                                {role === platformLayout.Platform ? <div className=''>
                                                    <h4 className='mb-2'>User Active</h4>
                                                    <p> <div className="toggle">
                                                        <input
                                                            type="checkbox"
                                                            id="checktoggle"
                                                            checked={isActive}
                                                            onChange={(e) => handleActiveInActive(e, user?._id)}
                                                        />
                                                        <label htmlFor="checktoggle"></label>
                                                    </div></p>
                                                </div> : null}
                                            </div>
                                            {userDetails?.clinicName ? <div className='col-lg-4 mb-3'>
                                                <h4>Hospital</h4>
                                                <p>{userDetails?.organizationName + "-" + userDetails?.clinicName}</p>
                                            </div> : null}
                                            <div className='col-lg-4 mb-3'>
                                                <h4>Address</h4>
                                                <p>{user?.city + "," + user?.state}</p>
                                            </div>
                                            <div className='col-lg-4 mb-3'>
                                                <h4>Account Status</h4>
                                                <td><div className={user?.isLocked === false ? "active_block_btn" : "not_active_btn"}>{user?.isLocked === false ? "Active" : "Locked"}</div></td>
                                            </div>
                                            {role === "Platform" && (
                                            <div className='col-lg-4 mb-3'>
                                                <Form onSubmit={formik.handleSubmit}>
                                                    <div>
                                                        <h4>Reset Password</h4>
                                                        <div className="d-flex align-items-center gap-2 mb-3">
                                                            <button
                                                                type="submit"
                                                                disabled={user?.isLocked === false}
                                                                style={{
                                                                    backgroundColor: user?.isLocked ? 'green' : 'gray',
                                                                    color: 'white',
                                                                    padding: '5px !important',
                                                                    border: 'none',
                                                                    borderRadius: '5px',
                                                                    fontSize: '14px !important',
                                                                    lineHeight:'20px !important'
                                                                }}
                                                            >
                                                                Reset Password
                                                            </button>
                                                        </div>
                                                    </div>
                                                </Form>
                                            </div>
                                            )}
                                            </div>
                                        </div>
                                        <div className="d-flex gap-3 justify-content-center mt-3">
                                            <button className="save_btn_blockk" type="submit" onClick={()=> setCurrentTab("userListing")}>Back</button>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </TabPane>
                        <TabPane tabId="2">
                            <div className='profile_main d-flex justify-content-between align-items-center flex-wrap gap-2 mb-3 table_listing_color'>
                                <div className='profile_info flex-wrap gap-2'>
                                    <div className="img_block">
                                        <div className="img_profile_container">
                                        {selectedImage ? (
                                            <img src={selectedImage} alt="Profile" className="img_profile_one" />
                                        ) : user?.profilePhoto?.signedUrl ? (
                                            <img src={user.profilePhoto.signedUrl} alt="Profile" className="img_profile_one" />
                                        ) : (
                                            <img src={noProfileImg} alt="No Profile" className="img_profile_one" />
                                        )}
                                        </div>
										<div className="edit_img">
											<i className='fas fa-pen'></i>
										</div>
										<input
											type="file"
											accept="image/*"
											onChange={handleImageChange}
											className="img_upload_input"
										/>
									</div>
                                    <div>
                                        <h6>{user?.firstName + " " + user?.lastName}</h6>
                                        <p>{user?.email}</p>
                                    </div>
                                </div>
                                <button className='edit_profile' onClick={() => setShowModal(true)}>Edit</button>
                            </div>
                            <div className="table_space">
                                <div className="table-responsive">
                                    <table>
                                        <thead>
                                            <tr className="header_table">
                                                <th></th>
                                                <th onClick={() => handleSort("name")}>Organization<i className='fas fa-sort'></i></th>
                                                <th>Status</th>
                                                <th onClick={() => handleSort("address")}>State<i className='fas fa-sort'></i></th>
                                                <th>Default Location</th>
                                                <th>Total Branches</th>
                                                <th>Access</th>
                                                <th>Actions</th>
                                            </tr>
                                        </thead>
                                        {filteredAndSortedData?.length > 0 ? filteredAndSortedData?.map(({ organization, clinics, defaultClinic }, orgIndex, index) => (
                                            <tbody key={organization?._id}>
                                                <tr>
                                                    <td colSpan={9} height={5} className="bg_light"></td>
                                                </tr>
                                                <tr className={index % 2 === 0 ? 'first_block' : 'second_block'}>
                                                    <td className="check_in" onClick={() => handleExpand(organization?._id)} ><i className={expandedOrg.includes(organization?._id) ? 'fas fa-caret-down' : 'fas fa-caret-right'}></i></td>
                                                    <td>
                                                        <Link
                                                            to="/super-admin/orgViewDetail"
                                                            className="title_name"
                                                            state={{ orgData: { ...organization, clinics } }}
                                                        >
                                                            <h6>{organization?.name}</h6>
                                                        </Link>
                                                    </td>
                                                    <td><div className={organization?.active === true ? "active_block_btn" : "not_active_btn"}>{organization?.active === true ? "Active" : "Not Active"}</div></td>
                                                    <td>{organization?.address?.[0]?.city + "," + organization?.address?.[0]?.state}</td>
                                                    <td>
                                                        <FormGroup check className="custom-checkbox">
                                                            <Input
                                                                type="radio"
                                                                id={`defaultOrg-${orgIndex}`}
                                                                name={`defaultOrg-${orgIndex}`}
                                                                onChange={(e) => organization?.active === true
                                                                    ? handleRadio(e, organization?._id, "", "org") : failed("This Organization is not active.")}
                                                                checked={organization?._id === assignedOrg?.defaultLogInOrg}
                                                            />
                                                        </FormGroup>
                                                    </td>
                                                    <td>{clinics?.length}</td>
                                                    <td>
                                                        <div className="toggle">
                                                            <input
                                                                type="checkbox"
                                                                id={`checktoggle-${organization._id}`}
                                                                onChange={(e) => handleOrgToggle(e, organization._id, clinics.map((obj) => obj?._id))}
                                                                checked={orgToggles[organization._id] ?? user?.organizations?.find((obj) => obj.organizationId == organization?._id)?.isAccess}
                                                            />
                                                            <label htmlFor={`checktoggle-${organization._id}`}></label>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <Dropdown isOpen={dropdownfive.includes(organization?._id)} toggle={() => togglefive(organization?._id)} direction={direction}>
                                                            <DropdownToggle caret size="xl" className="drop_blk">
                                                                <div className="for_details">
                                                                    <i className="fa fa-ellipsis-v"></i>
                                                                </div>
                                                            </DropdownToggle>
                                                            <DropdownMenu {...args}>
                                                                <DropdownItem className="d-flex gap-2 drop_block_content align-items-center" onClick={() => {navigate("/super-admin/orgViewDetail", { state: { orgData: { ...organization, clinics }}}), sessionStorage.setItem("breadCrumpEntityId", organization._id);}} >
                                                                    <div className="add_hosp" >View Details</div>
                                                                </DropdownItem>
                                                                <DropdownItem className="d-flex gap-2 drop_block_content align-items-center" onClick={() => handleRemoveAccess(userDetails?._id, organization?._id)}>
                                                                    <div className="add_hosp" >Remove Organization</div>
                                                                </DropdownItem>
                                                            </DropdownMenu>
                                                        </Dropdown>
                                                    </td>
                                                </tr>
                                                {expandedOrg.includes(organization?._id) && clinics?.length > 0 ? clinics?.map((clinic, clinicIndex) => (
                                                    <tr className="onclick_data" key={clinic?._id}>
                                                        <td className="check_in"></td>
                                                        <td>{organization?.name} - {clinic?.name}</td>
                                                        <td><div className={clinic?.active === true ? "active_block_btn" : "not_active_btn"}>{clinic?.active === true ? "Active" : "Not Active"}</div></td>
                                                        <td>{clinic?.address?.[0]?.city + "," + clinic?.address?.[0]?.state}</td>
                                                        <td>
                                                            <FormGroup check className="custom-checkbox">
                                                                <Input
                                                                    type="radio"
                                                                    id={`defaultClinic-${orgIndex}-${clinicIndex}`}
                                                                    name={`defaultClinic-${orgIndex}`}
                                                                    onChange={(e) => clinic?.active === true ? handleRadio(e, clinic?._id, "", "clinic", organization?._id) : failed("This branch is not active.")}
                                                                    checked={clinic?._id === defaultClinic}
                                                                />
                                                            </FormGroup>
                                                        </td>
                                                        <td></td>
                                                        <td><label className="switch" htmlFor={`checktoggle-${clinic._id}`}>
                                                            <input type="checkbox"
                                                                id={`checktoggle-${clinic._id}`}
                                                                onChange={(e) => handleClinicToggle(e, clinic._id, organization?._id, organization?.name)}
                                                                checked={clinicToggles[`${organization?._id}-${clinic._id}`] ?? user?.organizations?.find((obj) => obj.organizationId === organization?._id)?.clinicId.includes(clinic?._id)}
                                                            />
                                                            <span className="slider round"></span>
                                                        </label>
                                                        </td>
                                                        <td></td>
                                                    </tr>
                                                )) : null}
                                                <tr>
                                                    <td colSpan={9} height={5} className="bg_light"></td>
                                                </tr>
                                            </tbody>
                                        )) : <tr><td colSpan={10}><p className="text-center">No Data Found</p></td></tr>}
                                    </table>
                                </div>
                                <CustomPagination tableData={assignedOrg?.items} totalPages={assignedOrg?.totalPages} totalRows={assignedOrg?.totalItems} rowsPerPage={10} page={assignedOrg?.currentPage} handlePage={handlePagination} />
                            </div>
                            <div className='d-flex justify-content-center mt-3 gap-3'>
                                <button className="save_btn_blockk" type="submit" onClick={()=> setCurrentTab("userListing")}>Back</button>
                                <button
                                    className='acess_btn d-flex align-items-center gap-2'
                                    onClick={() => setShowModalAddOrg(true)}
                                    disabled={!hasOrganizationPortalLayout}
                                >
                                    <i className="fa fa-plus"></i>Add Organization Access
                                </button>
                            </div>
                        </TabPane>
                        <TabPane tabId="3" className='tab_three'>
                            <div className='profile_main d-flex justify-content-between align-items-center flex-wrap gap-3'>
                                <div className='profile_info flex-wrap'>
                                    <div className="img_block">
                                        <div className="img_profile_container">
                                        {selectedImage ? (
                                            <img src={selectedImage} alt="Profile" className="img_profile_one" />
                                        ) : user?.profilePhoto?.signedUrl ? (
                                            <img src={user.profilePhoto.signedUrl} alt="Profile" className="img_profile_one" />
                                        ) : (
                                            <img src={noProfileImg} alt="No Profile" className="img_profile_one" />
                                        )}
                                        </div>
                                        <div className="edit_img">
                                            <i className='fas fa-pen'></i>
                                        </div>
                                        <input
                                            type="file"
                                            accept="image/*"
                                            onChange={handleImageChange}
                                            className="img_upload_input"
                                        />
                                    </div>
                                    <div>
                                        <h6>{user?.firstName + " " + user?.lastName}</h6>
                                        <p>{user?.email}</p>
                                    </div>
                                </div>
                                <button className='edit_profile' onClick={() => setShowModal(true)}>Edit</button>
                            </div>
                            <div className="table_space">
                                <div className="table-responsive">
                                    <table>
                                        <thead>
                                            <tr className="header_table">
                                                <th onClick={() => handleSort("roleName")}>Role Name<i className='fas fa-sort'></i></th>
                                                <th>Active</th>
                                                <th>Default Role</th>
                                                <th onClick={() => handleSort("portalLayout")}>Portal Layout<i className='fas fa-sort'></i></th>
                                                <th></th>
                                            </tr>
                                        </thead>
                                        {filteredAndRolesSortedData?.length > 0 ? role == platformLayout.Organization ? filteredAndRolesSortedData.filter((obj) => obj.portalLayout !== platformLayout.Platform).map(({ value, roleIndex ,index}) => (
                                            <tbody key={value._id}>
                                                <tr>
                                                    <td colSpan={9} height={5} className="bg_light"></td>
                                                </tr>
                                                <tr  className={index % 2 === 0 ? 'first_block' : 'second_block'}>
                                                    <td>{value.roleName}</td>
                                                    <td><div className={value?.active === true ? "active_block_btn" : "not_active_btn"}>{value.active == true ? "Active" : "In Active"}</div></td>
                                                    <td>
                                                        <FormGroup check className="custom-checkbox">
                                                            <Input type="radio" id={`defaultRole-${roleIndex}`} name={`defaultRole`} onChange={() => handleRoleRadio(value)} checked={value?._id == userRoles?.defaultRole?.value?._id} />
                                                        </FormGroup>
                                                    </td>
                                                    <td>{value.portalLayout}</td>
                                                    <td>
                                                        <Dropdown isOpen={dropdownfive.includes(value?._id)} toggle={() => togglefive(value?._id)} direction={direction}>
                                                            <DropdownToggle caret size="xl" className="drop_blk">
                                                                <div className="for_details">
                                                                    <i className="fa fa-ellipsis-v"></i>
                                                                </div>
                                                            </DropdownToggle>
                                                            <DropdownMenu {...args}>
                                                                <DropdownItem className="d-flex gap-2 drop_block_content align-items-center">
                                                                    <div className="add_hosp" onClick={() => { setCurrentTab("rolesDetails"); roleData(value); }}> View Details</div>
                                                                </DropdownItem>
                                                                <DropdownItem className="d-flex gap-2 drop_block_content align-items-center">
                                                                    <div className="add_hosp" onClick={() => handleRemoveAccessRole(value)}>Remove Role</div>
                                                                </DropdownItem>
                                                            </DropdownMenu>
                                                        </Dropdown>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        )) : filteredAndRolesSortedData?.map(({ value, roleIndex,index }) => (
                                            <tbody key={value._id}>
                                                <tr>
                                                    <td colSpan={9} height={5} className="bg_light"></td>
                                                </tr>
                                                <tr className={index % 2 === 0 ? 'first_block' : 'second_block'}>
                                                    <td>{value.roleName}</td>
                                                    <td><div className={value?.active === true ? "active_block_btn" : "not_active_btn"}>{value.active == true ? "Active" : "Not Active"}</div></td>
                                                    <td>
                                                        <FormGroup check className="custom-checkbox">
                                                            <Input type="radio" id={`defaultRole-${roleIndex}`} name={`defaultRole`} onChange={() => handleRoleRadio(value)} checked={value?._id == userRoles?.defaultRole?.value?._id} />
                                                        </FormGroup>
                                                    </td>
                                                    <td>{value.portalLayout}</td>
                                                    <td>
                                                        <Dropdown isOpen={dropdownfive.includes(value?._id)} toggle={() => togglefive(value?._id)} direction={direction}>
                                                            <DropdownToggle caret size="xl" className="drop_blk">
                                                                <div className="for_details">
                                                                    <i className="fa fa-ellipsis-v"></i>
                                                                </div>
                                                            </DropdownToggle>
                                                            <DropdownMenu {...args}>
                                                                <DropdownItem className="d-flex gap-2 drop_block_content align-items-center">
                                                                    <div className="add_hosp" onClick={() => { setCurrentTab("rolesDetails"); roleData(value); }}>View Details</div>
                                                                </DropdownItem>
                                                                <DropdownItem className="d-flex gap-2 drop_block_content align-items-center">
                                                                    <div className="add_hosp" onClick={() => handleRemoveAccessRole(value)}>Remove Role</div>
                                                                </DropdownItem>

                                                            </DropdownMenu>
                                                        </Dropdown>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        )) : <tr><td colSpan={10}><p className="text-center">No Data Found</p></td></tr>}
                                    </table>
                                </div>
                            </div>
                            <div className='d-flex justify-content-center mt-3 gap-3'>
                                <button className="save_btn_blockk" type="submit" onClick={()=> setCurrentTab("userListing")}>Back</button>
                                <button className='acess_btn d-flex align-items-center gap-2' disabled={!isActive} onClick={() => setShowModalAddRole(true)}><i className="fa fa-plus"></i> Add Role Access </button>
                            </div>
                        </TabPane>
                    </TabContent>
                </div>
            </div>
        </Fragment>
    );
}

export default UserDetails;
